<template>
    <v-bottom-sheet v-model="$store.state.bookingSelectServiceDialogStatus" hide-overlay elevation="0">
      <v-card color="white" rounded="t-xl">
        <v-card-text class="px-1 pt-0">
          <v-row justify="center">
            <v-col cols="12" md="6">
              <v-card variant="text">
                <v-card-actions>
                  <h3>{{ $store.state.service.title }}</h3>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="$store.commit('setBookingSelectServiceDialogStatus', false)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-divider></v-divider>
                <v-card-text class="px-1">

                  <div class="d-flex flex-column">
                      <div class="d-flex justify-space-between">
                          <div style="flex-grow: 1;" class="pl-3">
                              <v-radio-group v-model="item_variable" v-if="$store.state.service.has_variable && !!$store.state.service.options && !!$store.state.service.options.varibles && $store.state.service.options.varibles.length > 0">
                                <v-radio
                                color="primary"
                                v-for="(variable,index) in $store.state.service.options.varibles"
                                :key="index"
                                :label="variable.name"
                                :value="variable"
                                :disabled="variable.total < 1"
                                ></v-radio>
                              </v-radio-group>
                          </div>
                          <ZoomableImage v-if="$store.state.service.image.length > 0" img-class="service-img" :src="$store.state.fileBaseUrl+$store.state.service.image" :alt="$store.state.service.title"/>
                      </div>
                      <template v-if="!!$store.state.service.options && !!$store.state.service.options.addons && $store.state.service.options.addons.length > 0">
                        <h4>افزودنی‌ها:</h4>
                        <div class="d-flex justify-space-between align-center"
                          v-for="(addon,index) in addons"
                          :key="`addon`+index">
                            <div class="d-flex align-center">
                              <v-checkbox hide-details density="compact"
                                color="primary"
                                v-model="selected_addons"
                                :label="addon.title"
                                :value="addon"
                                :disabled="addon.total >= addon.max"
                                >
                              </v-checkbox>
                              <div class="d-flex align-center mr-2" v-if="addon.countable && selected_addons.findIndex(e=>e.id ==addon.id) > -1">
                                <v-btn size="x-small" elevation="0" variant="outlined" icon="mdi-minus" color="primary" @click="addon.total==1?(selected_addons = selected_addons.filter(e=>e.id != addon.id)):addon.total--"></v-btn>
                                <strong class="mx-2">{{ addon.total }}</strong>
                                <v-btn size="x-small" elevation="0" variant="outlined" icon="mdi-plus" color="primary"  @click="addon.total == addon.max ?(addon.total=addon.max):addon.total++"></v-btn>
                              </div>
                            </div>
                            <div>
                              <strong>{{ new Intl.NumberFormat('fa-IR').format(addon.price) }}</strong>
                              {{ $t('rial') }}
                            </div>
                        </div>
                      </template>
                      <div class="d-flex justify-space-between align-center">
                          <div>
                              <strong>{{ new Intl.NumberFormat('fa-IR').format(TotalPrice) }}</strong>
                              {{ $t('rial') }}
                          </div>
                          <v-btn
                              @click="$store.commit('setService', {service:$store.state.service,variable:item_variable,addons:selected_addons,checked:true});"
                              color="primary" variant="outlined" rounded="lg" class="mt-4">
                              {{ $t('booking.reserve_button') }}
                          </v-btn>
                      </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </template>
  
<script>
  import ZoomableImage from '@/components/ZoomableImage.vue';

  export default {
    name: "SelectServicePage",
    components: {
      ZoomableImage,
    },
    data() {
      return {
        item_variable: {},
        addons:[],
        selected_addons:[],
      }
    },
    computed:{
      TotalPrice(){
        let price = 0;
        if(this.item_variable.price){
          price += Number.parseInt(this.item_variable.price)
        }else{
          price += Number.parseInt(this.$store.state.service.price);
        }
        if(this.selected_addons.length >0){
          price += this.selected_addons.reduce((sum, item) => {
            return sum + (item.price * item.total);
          }, 0);
        }
        return price;
      }
    },
    created(){
      if(this.$store.state.service.has_variable && !!this.$store.state.service.options && !!this.$store.state.service.options.varibles && this.$store.state.service.options.varibles.length > 0){
        let vars = this.$store.state.service.options.varibles.filter(e=>e.total > 0);
        if(vars.length > 0){
          this.item_variable =  vars[0];
        }
      }
      
      if(!!this.$store.state.service.options && !!this.$store.state.service.options.addons && this.$store.state.service.options.addons.length > 0){
        const services = this.$store.state.info.serives;
        const addons = this.$store.state.service.options.addons;

        this.addons = addons
          .map(addon => {
            const service = services.find(se => se.id === addon.id);
            if (service) {
              return {
                id: service.id,
                title: service.title,
                price: Number.parseInt(service.price),
                countable: addon.countable,
                total: 1,
                max:service.total
              };
            }
            return null;
          })
          .filter(item => item !== null);
      }
    },
  }
  </script>
  
  <style>
  .v-slide-group__next,
  .v-slide-group__prev {
    min-width: 30px !important;
  }
  </style>